export default {
  masterlist: [],
  masterlistItem: {}
};
